<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :deleteAction="model._id ? model.can_delete ? deleteAction : false : false"
        :actionButtons="!hideForm"
        size="full"
        :closeButton="hideForm"
        @shown="shown() "
    >
        <div class="row" v-if="parent">
            <div class="col">
                <div class="card card-inactive">
                    <div class="card-body p-3">:: {{ parent.label }}</div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <b-form-group :label="$t('Label')">
                    <b-form-input v-model="model.label"></b-form-input>
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <b-form-group :label="$t('Code')">
                    <b-form-input v-model="model.code"></b-form-input>
                </b-form-group>
            </div>

            <div class="col">
                <b-form-group :label="$t('Language')">
                    <b-form-select v-model="model.language" :options="languages"></b-form-select>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-12">
                <b-form-group :label="$t('Description')">
                    <b-form-textarea v-model="model.description"></b-form-textarea>
                </b-form-group>
            </div>
            <div class="col-12 col-md-12">
                <div class="form-group">
                    <custom-switch v-model="model.featured" id="featured" :title="$t('Featured')"></custom-switch>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import IcdSelector from '@/components/ICD10/IcdSelector'
import CustomSwitch from "@/components/CustomSwitch.vue";
import { mapActions, mapGetters, mapState } from 'vuex';


export default {
    name: 'ICD-modal',
    props: ['id', 'saveAction', 'data'],
    components: {
        Modal,
        IcdSelector,
        CustomSwitch,
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            languages: [
                { text: 'Russian', value: 'russian' },
                { text: 'English', value: 'english' },
            ],
            model: {
                language: 'russian'
            },
            title: 'ICD-10',
        }
    },
    computed: {
        ...mapState('icd', { icdLoading: 'isFindPending' }),
        ...mapGetters('icd', { findIcdInStore: 'find', getIcd: 'get' }),

        icd() {
            return this.findIcdInStore().data;
        },
        parent() {
            return this.getIcd(this.model.parentId);
        },

        delete() {
            if (!this.model._id) return false;
            return this.model.can_delete ? this.deleteAction : false;
        }
    },
    mounted() {

        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        return this.find({ query: {} }).data;

    },

    methods: {
        ...mapActions('icd', ['find', 'create', 'patch', 'remove']),

        deleteAction() {

            this.remove(this.model._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been removed')
                });
            });
        },

        save() {
            let promise, successMessage;
            if (this.model._id) {
                promise = this.patch([this.model._id, this.model]);
                successMessage = 'ICD has been saved';
            } else {
                promise = this.create(this.model);
                successMessage = 'ICD has been created';
            }

            promise.then(result => {

                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });

            });

        },

        shown() {
            /* Switch back to the first tab */
            this.model = this.data;
            this.model.language = 'russian';

        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        }
    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
